import {useEffect} from 'react';

import {aiAssistantContextStore} from '@dms/ai-assistant';
import type {MenuDynamicAccessKey, Register} from '@dms/api/shared';

import {syncReachableRouteIds} from '../../hooks/useRegisterModules/utils/syncReachableRouteIds';

interface AiAssistantReachableRoutesSyncProps {
  register: Pick<Register, 'reachableRoutePaths'>;
  dynamicAccess: Record<MenuDynamicAccessKey, boolean>;
}

export function AiAssistantReachableRoutesSync(props: AiAssistantReachableRoutesSyncProps): null {
  // Reachable routes synchronize an external store when access changes. This fits none of the
  // approved no-useEffect patterns, and the cleanup clears stale routes when this sync unmounts.
  // `useMenuDynamicAccess` returns a fresh object each render, so this effect re-runs often;
  // `syncReachableRouteIds` drops equal values, so repeated runs notify no subscriber.
  useEffect(
    function syncPermissionFilteredRoutesToAssistantContext() {
      syncReachableRouteIds(props.register, props.dynamicAccess);

      return () => {
        aiAssistantContextStore.patchContext({reachableRouteIds: []});
      };
    },
    [props.dynamicAccess, props.register]
  );

  return null;
}
